import { QCChecklistTemplateMatchedItem } from './qc-checklist-template-matched-item.model';

/**
 * Match endpoint response. `templateId` is null when no active template
 * matches the treatment dimensions.
 */
export interface QCChecklistTemplateMatchResult {
    readonly templateId: number | null;
    readonly templateName: string | null;
    readonly items: ReadonlyArray<QCChecklistTemplateMatchedItem>;
}
